import { ClusterReliabilityMetricsQueryData } from 'hooks/queries/cost/useClusterReliabilityMetricsQuery';
import { WorkloadReliabilityMetricsQueryData } from 'hooks/queries/cost/useWorkloadReliabilityMetricsQuery';

type ReliabilityMetricValue = { value?: number };
type ReliabilityMetric = {
  summary?: number;
  values?: ReliabilityMetricValue[];
};

type LatencyKey =
  | keyof Pick<
      WorkloadReliabilityMetricsQueryData,
      'latencyP50' | 'latencyP95' | 'latencyP99'
    >
  | keyof Pick<
      ClusterReliabilityMetricsQueryData,
      'latencyP50' | 'latencyP95' | 'latencyP99'
    >;

export type ReliabilityData = Partial<Record<LatencyKey, ReliabilityMetric>>;

// Latency is returned in seconds by the backend; convert to milliseconds.
const convertLatencyMetricToMs = <M extends ReliabilityMetric>(
  metric: M | undefined
): M | undefined => {
  if (!metric) return undefined;
  return {
    ...metric,
    summary:
      metric.summary !== undefined && metric.summary !== 0
        ? metric.summary * 1000
        : undefined,
    values: metric.values?.map((v) => ({ ...v, value: (v.value ?? 0) * 1000 })),
  };
};

export const convertLatencyToMs = <T extends ReliabilityData>(data: T): T => ({
  ...data,
  latencyP50: convertLatencyMetricToMs(data.latencyP50),
  latencyP95: convertLatencyMetricToMs(data.latencyP95),
  latencyP99: convertLatencyMetricToMs(data.latencyP99),
});
